import { render, staticRenderFns } from "./TopCustomerTable.vue?vue&type=template&id=401c590c"
import script from "./TopCustomerTable.vue?vue&type=script&lang=js"
export * from "./TopCustomerTable.vue?vue&type=script&lang=js"
import style0 from "./TopCustomerTable.vue?vue&type=style&index=0&id=401c590c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports